exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-c6565320]{width:11.146vw;user-select:none;font-family:Nunito,sans-serif;background:none;padding:1.5vh 2.5vw;margin-top:6.7vh;font-weight:600;font-size:1.667vw;color:#3cf;border:solid;border-color:#3cf;border-radius:3vw;border-width:.18vw;background-position:50%;transition:background .8s}.btn[data-v-c6565320]:hover{background-color:#3cf;color:#fff;outline:none;background:#3cf radial-gradient(circle,transparent 1%,#70ddff 0) 50%/15000%}.btn[data-v-c6565320]:active{outline:none;border-style:none;padding:1.83vh 2.68vw;background-color:#70ddff;background-size:100%;border-color:#70ddff;transition:background 0s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6565320","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login-gmail.vue
// module id = 1203
// module chunks = 0